import { useEffect, useRef, useState } from "react"
import Loader from "../../components/Loader"
import { useRequest } from "../../hooks/useRequest"
import { mountEmbeddedSupportChat, refreshSupportUser, unmountEmbeddedSupportChat } from "../../lib/chatwoot"
import { appStore } from "../../store/appStore"
import { userStore } from "../../store/userStore"
import { User } from "../../types/entities/user"

export default function SupportChatPanel() {
    const containerRef = useRef<HTMLDivElement>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const { user, setUser, deviceToken } = userStore()
    const { city, cinema } = appStore()
    const { request } = useRequest()

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        let active = true
        setLoading(true)
        setError(null)

        const start = async () => {
            const currentUser = await refreshSupportUser(user, () =>
                request<User>("GET", `user?city_id=${city.id}`, undefined, { disableError: true })
            )
            if (!active) return
            if (currentUser) setUser(currentUser)

            if (!active) return

            await mountEmbeddedSupportChat(
                container,
                {
                    user: currentUser,
                    deviceToken,
                    cityId: city.id,
                    cityName: city.name,
                    cinemaName: cinema.name
                },
                () => active
            )
        }

        start()
            .then(() => {
                if (active) setLoading(false)
            })
            .catch((err: unknown) => {
                console.error(err)
                if (active) {
                    setError("Не удалось загрузить чат поддержки")
                    setLoading(false)
                }
            })

        const revealWhenMounted = window.setInterval(() => {
            if (!active) return
            if (container.querySelector("#cw-widget-holder")) {
                setLoading(false)
            }
        }, 200)

        return () => {
            active = false
            window.clearInterval(revealWhenMounted)
            unmountEmbeddedSupportChat()
        }
    }, [user?.id, deviceToken, city.id, city.name, cinema.name])

    return (
        <div className="relative h-[calc(100dvh-8rem)]">
            {loading && (
                <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[14px] bg-[#243c5a]">
                    <Loader frame />
                </div>
            )}
            {error && !loading && <div className="absolute inset-x-0 top-0 z-10 p-4 text-error">{error}</div>}
            <div ref={containerRef} className="h-full w-full overflow-hidden rounded-[14px] bg-[#243c5a]" />
        </div>
    )
}
